import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent, StatusIconComponent } from '@mode/capra';

@Component({
  selector: 'mode-view-page-banner',
  templateUrl: './view-page-banner.component.html',
  styleUrls: ['./view-page-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, StatusIconComponent, IconComponent],
})
export class ViewPageBannerComponent {
  /**
   * Banner status: 'info' (blue), 'warning' (yellow), or 'error' (red)
   */
  @Input() status: 'info' | 'warning' | 'error' = 'info';
}
